import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import ApiError from '../../../../components/Errors/ApiError';
import { useRecentCertifications } from '../../myTeamQueries';
import { Table } from 'foundations-components/transitional/components/Table';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import UserAvatarLink from '../common/UserAvatarLink';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import CertificationLink from '../common/CertificationLink';
import { getPaginatedPosition } from '../../utils/paginationUtils';
import EmptyOverviewCard from '../common/EmptyOverviewCard';
import { MY_TEAM_OVERVIEW_PAGE_SIZE } from '../../../pagination';
import { usePaginatedTable } from '../../hooks/usePaginatedTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const RecentCertifications = () => {
  const {
    isDesktop,
    isMobile
  } = useMediaQuery();
  const {
    recentCertifications,
    recentCertificationsLoading,
    recentCertificationsError
  } = useRecentCertifications();
  const {
    startIndex,
    paginatedData: certificationsToDisplay,
    pageCount,
    pageNumber,
    handlePageChange
  } = usePaginatedTable(recentCertifications, MY_TEAM_OVERVIEW_PAGE_SIZE);
  if (recentCertificationsLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      layout: "centered",
      minHeight: "350px",
      size: "medium"
    });
  }
  if (recentCertificationsError || !recentCertifications) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "UPCOMING_CERTIFICATION_EXPIRATIONS_API_ERROR",
      children: /*#__PURE__*/_jsx(ApiError, {
        error: {
          status: 500
        }
      })
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "RECENT_CERTIFICATIONS_LOADED",
    children: certificationsToDisplay.length > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        condensed: true,
        "data-test-id": "recent-certifications-table",
        truncated: isMobile,
        children: [/*#__PURE__*/_jsxs("colgroup", {
          children: [/*#__PURE__*/_jsx("col", {
            width: "40%"
          }), /*#__PURE__*/_jsx("col", {
            width: "35%"
          }), /*#__PURE__*/_jsx("col", {
            width: "25%"
          })]
        }), /*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.teamMembers.recentCertifications.table.name"
              })
            }), /*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.teamMembers.recentCertifications.table.certification"
              })
            }), /*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.teamMembers.recentCertifications.table.completed"
              })
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: certificationsToDisplay.map((cert, index) => {
            const position = getPaginatedPosition(startIndex, index);
            return /*#__PURE__*/_jsxs("tr", {
              "data-test-id": "recent-certification-row",
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(UserAvatarLink, {
                  displayAvatar: isDesktop,
                  position: position,
                  userEmail: cert.userEmail,
                  userId: cert.userId,
                  userName: cert.userName
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(CertificationLink, {
                  certificationId: cert.certificationId,
                  certificationName: cert.certificationName,
                  position: position,
                  showIcon: false
                })
              }), /*#__PURE__*/_jsx("td", {
                children: cert.completedAt && /*#__PURE__*/_jsx(FormattedDateTime, {
                  format: "ll",
                  value: cert.completedAt
                })
              })]
            }, `${cert.userId}-${cert.certificationId}-${index}`);
          })
        })]
      }), /*#__PURE__*/_jsx(Paginator, {
        onPageChange: handlePageChange,
        page: pageNumber,
        pageCount: pageCount,
        showButtonLabels: false
      })]
    }) : /*#__PURE__*/_jsxs(EmptyOverviewCard, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.certifications.noCertifications"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.certifications.findContent"
      })]
    })
  });
};
export default RecentCertifications;